<template>
	<div>
		<div class="inputItemDiv"><div class="inputTitleDiv">ファイル選択</div><input type="file" @change="onSelectFile"></div>

		
		<div class="inputItemDiv"><div class="inputTitleDiv">発売月</div><input class="input" type="text" v-model="catalog.releasedate"></div>
		<div class="inputItemDiv" v-show="!resReleaseDateVal"><div class="inputErrorTitleDiv"></div><span class="validateError">入力必須。YYYY年MM月形式、半角数値0詰めで入力して下さい。</span></div>

		<div class="inputItemDiv"><div class="inputTitleDiv">説明</div><input class="input" type="text" v-model="catalog.remark"></div>
		<div class="inputItemDiv" v-show="!resRemarkVal"><div class="inputErrorTitleDiv"></div><span class="validateError">入力必須。50桁以内で入力して下さい。</span></div>
		
		<div class="inputItemDiv"><div class="inputTitleDiv">注文締切日</div>
			<div style="display:flex">
				<v-date-picker v-model="catalog.orderlimitdate" :masks="masks" >
					<template v-slot="{ inputValue, inputEvents }">
						<input
							class="inputCalendar"
							:value="inputValue"
							v-on="inputEvents"
						/>
					</template>
				</v-date-picker>
				<button
					type="button"
					class="text-white font-bold py-2 px-4 rounded-r user-select-none focus:outline-none"
					:disabled="!catalog.orderlimitdate"
					@click="catalog.orderlimitdate = null">Clear
				</button>
			</div>
		</div>
		<br>
		
		<div class="inputItemDiv" style="text-align:right">
			<button  type="button" class="button" @click='cancel'>ｷｬﾝｾﾙ</button>
			<button :disabled="resAllVal"  type="button" class="button" @click='regist'>登録</button>
		</div>

		<div v-show="isProgressVisible" style=" border-radius: 5px;border:solid 1px;position:absolute;top:100px;left:200px;width:300px;height:140px;background:#f5f5f5">
		カタログ登録中...
		<br>
		<center>
        <circle-progress 
          :is-gradient="true" 
          :gradient="{
          angle: 90,
          startColor: '#ff0000',
          stopColor: '#ffff00'}"
          :size='100'
          :percent=percent 
/>
</center>
		</div>

	</div>

</template>

<script>
import catalogValidator from '../composables/CatalogValidator'
import catalogRepository from '../composables/CatalogRepository'
//import { useRoute, useRouter  } from 'vue-router'
import "vue3-circle-progress/dist/circle-progress.css";
import CircleProgress from "vue3-circle-progress";
import {ref, onMounted} from 'vue';

//import { convertDateFormat, convertDateToDateMonth  } from '../api/formatUtils'



export default ({
  name: 'EditCatalog',
  components: {CircleProgress},
  props: {
    id: String
  },

  setup(props, context){
 
    const file = ref()
    let percent = ref(0)
    
    const catalog = ref({id:'',releasedate:'',filepath:'',filename:'', filesize:'',remark:''})    

    
   onMounted(() => {
      console.log("on mount")
    })
    
 
    
  
    //GoodsRepositoryモジュールからの変数、メソッドを宣言
    const { getCatalogById, registCatalog } = catalogRepository()

    
    //データ取得時のコールバック( GoodsRepositoryのgetGoodsByIdメソッドに渡す)
    const getCallback = ( result ) =>{
      if( result != "success"){
        context.emit( 'setMessage', result )
      }
      console.log(catalog.value.releasedate)
    }
    

    
    
 
    //CatalogValidatorモジュールからの変数、メソッドを宣言
    const{ resRemarkVal, resReleaseDateVal, resAllVal } = catalogValidator( catalog, file )


    //登録ボタン押下時の処理
    const regist = () => {
      isProgressVisible.value = true
      registCatalog( file.value, catalog.value, regCallback, uploadProgressCallback )
    }
    
    //登録ボタン押下時のコールバック( GoodsRepositoryのregistGoodsメソッドに渡す)
    const regCallback = ( result, data ) =>{
      isProgressVisible.value = false
      if( result == "success"){
        context.emit( 'setMessage', "登録完了" )
        
        //登録したカタログをリストに追加するように依頼
        context.emit( 'addRegistedCategoryToList', data )
      }else{
        context.emit( 'setMessage', result )
      }
      
      context.emit( 'setIsEdit', false )

    }

    if( props.id != null ){
      getCatalogById( props.id, getCallback  )
    }
    
    
    const uploadProgressCallback = (e)=>{
        console.log( "total:" + e.total )
        console.log( "progress:" + e.loaded )  
        
        percent.value =  e.loaded / e.total * 100
        
    }
    
    //ｷｬﾝｾﾙ処理
    const cancel = () => {
      console.log("cancel")
      context.emit( 'setIsEdit', false )
    }
    

    
    const onSelectFile = (e) =>{
		const files = e.target.files;

		if(files.length === 0) {    // ファイル選択がキャンセルされた時

			file.value = null;
			return;

		}

		file.value = files[0];
		console.log( file.value )
    }
    
    const isProgressVisible = ref(false)
    //template上で使用する変数を宣言
    return{
      catalog,
      regist,
      cancel,
      resRemarkVal,
      resReleaseDateVal,
      resAllVal,
      onSelectFile,
      file,
      isProgressVisible,
      percent,
      masks: {
        input: 'YYYY/MM/DD',
      }
    }
  }

})

</script>


